import type { ReactElement } from 'react';

import styles from './SchemeChip.module.css';

/**
 * Перенос `_SchemeChip` из `base_url_page.dart`.
 *
 * Схема перед доменом. Угадывается по вводу, нажатие переключает вручную.
 */

/**
 * `Icon(Icons.swap_horiz)`.
 *
 * Material-иконки в вебе взять неоткуда: в проекте только свои SVG из
 * `AppIcons`, шрифта иконок нет. Контур перерисован из Material-набора
 * один в один (сетка 24×24), цвет наследуется от чипа.
 */
const SWAP_HORIZ_PATH =
  'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z';

/** `Icon(..., size: 20)` */
const SWAP_HORIZ_SIZE = 20;

/** Сетка, в которой нарисованы Material-иконки. */
const ICON_VIEW_BOX = '0 0 24 24';

export interface SchemeChipProps {
  readonly scheme: string;
  readonly onTap: () => void;
}

export function SchemeChip({ scheme, onTap }: SchemeChipProps): ReactElement {
  return (
    <div className={styles.root}>
      <button
        type="button"
        data-testid="scheme-chip"
        className={styles.chip}
        onClick={onTap}
      >
        <span className={styles.label}>{`${scheme}://`}</span>
        <svg
          className={styles.icon}
          width={SWAP_HORIZ_SIZE}
          height={SWAP_HORIZ_SIZE}
          viewBox={ICON_VIEW_BOX}
          aria-hidden="true"
          focusable="false"
        >
          <path d={SWAP_HORIZ_PATH} fill="currentColor" />
        </svg>
      </button>
    </div>
  );
}
